import { SidebarProvider } from "../context/SidebarContext";
import { useSidebar } from "../hooks/useSidebar";
import { Outlet } from "react-router";
import AppHeader from "./AppHeader";
import Backdrop from "./Backdrop";
import AppSidebar from "./AppSidebar";
import { TourProvider } from "@/features/tour";

const LayoutContent: React.FC = () => {
	const { isExpanded, isHovered, isMobileOpen } = useSidebar();

	return (
		<div className="min-h-screen xl:flex">
			<div>
				<AppSidebar />
				<Backdrop />
			</div>
			<div
				className={`flex-1 transition-all duration-300 ease-in-out ${
					isExpanded || isHovered ? "lg:ml-[256px]" : "lg:ml-[64px]"
				} ${isMobileOpen ? "ml-0" : ""}`}
			>
				<AppHeader />
				<Outlet />
			</div>
		</div>
	);
};

const AppLayout: React.FC = () => {
	return (
		<SidebarProvider>
			<TourProvider>
				<LayoutContent />
			</TourProvider>
		</SidebarProvider>
	);
};

export default AppLayout;
